import { ReactLocalization } from "@fluent/react";
import { z } from "zod";
import { Institution } from "@lending/types";
import {
  createValidateDateOfBirth,
  createValidatePhone,
  createValidateSSN,
} from "@lending/utils/validators";

export function createSchema(l10n: ReactLocalization, institution: Institution) {
  const requiredMessage = l10n.getString("error-required", null, "Required");

  return z.object({
    first_name: z.string().min(1, { message: requiredMessage }),
    last_name: z.string().min(1, { message: requiredMessage }),
    tax_id: createValidateSSN(l10n),
    date_of_birth: createValidateDateOfBirth(l10n, institution),
    email: z
      .string()
      .min(1, { message: requiredMessage })
      .email({ message: l10n.getString("error-invalid-email", null, "Enter a valid email") }),
    phone: createValidatePhone(l10n),
  });
}
